import { inferRouteObject } from 'react-router-typed-object';

import Authentication from 'src/scenes/Authentication/index.ts';

const index = true;

export const mcpAuthorizeRouteObject = inferRouteObject({
  path: 'mcp-authorize',
  Component: Authentication.Components.McpSessionGuard,
  children: [
    {
      Component: Authentication.Components.Layout,
      children: [{ index, Component: Authentication.Components.McpAuthorize }],
    },
  ],
});
